import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAppConfigStore } from '@/stores/app-config-store'
import type { ClientUrlSegmentClientDataMap } from '@/stores/app-config-store'

export const useCurrentClient = () => {
  const route = useRoute()
  const appConfigStore = useAppConfigStore()

  const currentClientData = computed((): ClientUrlSegmentClientDataMap | null => {
    const pathSegments = route.path.split('/')
    const clientSegment = pathSegments[1] // First segment after domain

    if (clientSegment && appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]) {
      return appConfigStore.CLIENT_URL_SEGMENT_CLIENT_DATA_MAP[clientSegment]
    }

    return null
  })

  const currentClientCode = computed(() => currentClientData.value?.clientCode || null)
  const currentClientName = computed(() => currentClientData.value?.clientName || null)
  const currentClientLogoUrl = computed(() => currentClientData.value?.logoUrl || null)
  const currentClientFaviconUrl = computed(() => currentClientData.value?.faviconUrl || null)
  const currentClientStatus = computed(() => currentClientData.value?.status || null)
  const currentClientSubscriptionPlanId = computed(() => currentClientData.value?.subscriptionPlanId || null)
  const currentClientSubscriptionFeatures = computed(() => currentClientData.value?.subscriptionFeatures || null)
  const currentClientUriSegment = computed(() => {
    const pathSegments = route.path.split('/')
    return pathSegments[1] || null
  })

  return {
    currentClientData,
    currentClientCode,
    currentClientName,
    currentClientLogoUrl,
    currentClientFaviconUrl,
    currentClientStatus,
    currentClientSubscriptionPlanId,
    currentClientSubscriptionFeatures,
    currentClientUriSegment,
  }
}
